module.exports = __webpack_public_path__ + "static/media/468x468.de8a7cc6.jpg";